import(/* webpackMode: "eager" */ "/Volumes/Crucial 1TB X9/Documents/Rank Craft Ai/projects/luluwild/site/node_modules/next/dist/client/app-dir/link.js");
